import { apiGet } from '@gat-ship/http-client'
import type { CompanyRef } from '@gat-ship/types'

export async function getCompanyRefsRequest() {
  return await apiGet<CompanyRef[]>('ref-data/organization/companies')
}
